<div id="overlay" [ngClass]="{ 'hide-spinner': !isLoading }">
  <p-progressBar
    mode="indeterminate"
    [style]="{ height: '4px' }"
  ></p-progressBar>
</div>
